/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DrugOrderDosageDto
 */
export interface DrugOrderDosageDto {
    /**
     * 
     * @type {number}
     * @memberof DrugOrderDosageDto
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DrugOrderDosageDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DrugOrderDosageDto
     */
    'orderPeriod'?: DrugOrderDosageDtoOrderPeriodEnum;
    /**
     * 
     * @type {string}
     * @memberof DrugOrderDosageDto
     */
    'orderTime'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum DrugOrderDosageDtoOrderPeriodEnum {
    Morning = 'MORNING',
    Noon = 'NOON',
    Evening = 'EVENING'
}


